export var PartnerTransferSection;
(function (PartnerTransferSection) {
    PartnerTransferSection["PartnerTransfer"] = "PartnerTransfer";
    PartnerTransferSection["Investments"] = "Investments";
    PartnerTransferSection["Expenses"] = "Expenses";
    PartnerTransferSection["Income"] = "Income";
    PartnerTransferSection["Fees"] = "Fees";
    PartnerTransferSection["LinkedCapitalActions"] = "LinkedCapitalActions";
    PartnerTransferSection["GeneralCapitalActions"] = "GeneralCapitalActions";
    PartnerTransferSection["AdvanceSubscriptions"] = "AdvanceSubscriptions";
    PartnerTransferSection["Summary"] = "Summary";
})(PartnerTransferSection || (PartnerTransferSection = {}));
export var PartnerTransferTypes;
(function (PartnerTransferTypes) {
    PartnerTransferTypes["PartnerTransfer"] = "partnerTransfer";
})(PartnerTransferTypes || (PartnerTransferTypes = {}));
//# sourceMappingURL=index.js.map